import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';

import './Resources/dashboard.css';
import axios from './../axios.js';
import Navbar from './Supportingfiles/navbar';
import Sidebar from './Supportingfiles/sidebar';
//import Create_loanrequests from './create_newaccounts';
import moment from 'moment/moment';


function Admin_edit_team(){

  
  //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const logname=sessionStorage.getItem("logName00");
 const editId=sessionStorage.getItem("EditId00");

 //SETTING DATA VARIABLES
 const[code,setcode]=useState();const updatecode = (event) => { setcode(event.target.value);}; const[code_er,setcode_er]=useState();
 const[name,setname]=useState();const updatename = (event) => { setname(event.target.value);}; const[name_er,setname_er]=useState();
 const[username,setusername]=useState();const updateusername = (event) => { setusername(event.target.value);}; const[username_er,setusername_er]=useState();
 const[password,setpassword]=useState();const updatepassword = (event) => { setpassword(event.target.value);}; const[password_er,setpassword_er]=useState();
 const[confirm_password,setconfirm_password]=useState();const updateconfirm_password = (event) => { setconfirm_password(event.target.value);}; const[confirm_password_er,setconfirm_password_er]=useState();
 const[remarks,setremarks]=useState();const updateremarks = (event) => { setremarks(event.target.value);}; const[remarks_er,setremarks_er]=useState();
 const[type,settype]=useState();const updatetype = (event) => { settype(event.target.value);}; const[type_er,settype_er]=useState();
 const[admin_status,setadmin_status]=useState();const updateadmin_status = (event) => { setadmin_status(event.target.value);}; const[admin_status_er,setadmin_status_er]=useState();
 
 
 //ERROR VARIABLES 
 const[error_msg,seterror_msg]=useState();



useEffect(()=>{
   
  getData();
  
  },[])
 

//******************* GET TEAM DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&(editId>0)){
 
 axios.post("teamdetails", {
   Log_id:logid,
   Token:token,
   Edit_id:editId


   })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("logName00");
     sessionStorage.removeItem("EditId00");
     window.location.replace("/");
  }


  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setcode(response.data.code);
   setname(response.data.name);
   setusername(response.data.username);
   settype(response.data.type);
   setremarks(response.data.remarks);
   setadmin_status(response.data.team_status);

  }

  //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){ seterror_msg("Validation error!"); }

  //Data Violation
  if(response.data.error==102){  seterror_msg("Violation Error"); }

 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("logName00");
   sessionStorage.removeItem("EditId00");
   window.location.replace("/");
 
  }
 
 }
  
 //******************* GET TEAM DATA FUNCTION END  ********************//

 

/***************** EDIT TEAM FUNCTION START  ******************/
function edit_team(){

  
  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((logname!=null)||(logname!=" "))&&(editId>0)){


    //Setting Error Variables
    setcode_er(" ");setname_er(" ");setusername_er(" ");setpassword_er(" ");setconfirm_password_er(" ");seterror_msg(" ");//settype_er(" ");
   
    
//Fetching Form Data
let noerror = 0;
const $code = document.getElementById("code").value; if($code==""){ setcode_er("Code is required !");noerror = noerror+1; }//code
const $name = document.getElementById("name").value; if($name==""){ setname_er("Name is required !");noerror = noerror+1; }//name
const $username = document.getElementById("username").value; if($username==""){ setusername_er("Username is required !");noerror = noerror+1; }//username
const $password = document.getElementById("password").value; if($password==""){ setpassword_er("Password is required !");noerror = noerror+1; }//password
const $confirm_password = document.getElementById("confirm_password").value; if($confirm_password==""){ setconfirm_password_er("Confirm Password is required !");noerror = noerror+1; }//confirm_password
const $remarks = document.getElementById("remarks").value;// if($employee_remarks==""){ setemployee_remarks_er("Employee Remarks is required !");noerror = noerror+1; }//employee_remarks
const $type = document.getElementById("type").value;// if($type==""){ settype_er("type is required !");noerror = noerror+1; }//type
const $admin_status = document.getElementById("admin_status").value;// if($employee_status==""){ setemployee_status_er("Employee Status is required !");noerror = noerror+1; }//employee_status



//No primary errors
if(noerror==0){

     //disabling button
    // document.getElementById('emp-submit-btn').disabled = true; 

    
  const addBtn = document.getElementById("emp-submit-btn");
  addBtn.disabled = true;
  addBtn.innerText = "Processing..."; // optional


  //Sending Data through axios
  axios.post("editteamdetails", { 
  Log_id:logid,
  Token:token,
  Edit_id:editId,
  Code:$code,
  Name:$name,
  Username:$username,
  Password:$password,
  Confirm_password:$confirm_password,
  Remarks:$remarks,
  Type:$type,
  Team_status:$admin_status

  },{
    headers: { "Content-Type": "multipart/form-data" },
    }
    )
  
  .then((response) => {

      //enabling button
     // document.getElementById('emp-submit-btn').disabled = false; 
      
    // In case of network or server error
    addBtn.disabled = false;
    addBtn.innerText = "Edit Team Member";


  //Validation Errors
  if(response.data.validatorerror){
  setcode_er(response.data.validatorerror.Code);
  setname_er(response.data.validatorerror.Name);
  setusername_er(response.data.validatorerror.Username);
  setpassword_er(response.data.validatorerror.Password);
  setconfirm_password_er(response.data.validatorerror.Confirm_password);
  setremarks_er(response.data.validatorerror.Admin_remarks);
  setadmin_status_er(response.data.validatorerror.Team_status);
  //settype_er(response.data.validatorerror.Type);
  seterror_msg("Cannot Edit Team Member!");
  

  }
  //Invalid Entries
  if(response.data.error==102){ 

  setcode_er(response.data.code_er);
  setname_er(response.data.first_name_er);
  setusername_er(response.data.username_er);
  setpassword_er(response.data.password_er);
  setconfirm_password_er(response.data.confirm_password_er);
  setremarks_er(response.data.admin_remarks_er);
  setadmin_status_er(response.data.team_status_er);
  settype_er(response.data.type_er);
  seterror_msg("Cannot Edit Team Member !");
  
  
  }
  
  //Branch Name or Branch Code Already Exists
  if(response.data.error==103){  seterror_msg(response.data.error_msg); return; }
  
  //Success
  if(response.data.successvar==1){ document.getElementById("success-card").style.display="block"; }

  //failure
  if(response.data.successvar==6){ seterror_msg("Admin Not Editted !"); }

  //Session Expired
  if(response.data.successvar==100){ seterror_msg("Session Expired !");  }


  }    );
  
  }
  

  }
  //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
 sessionStorage.removeItem("logStatus00");
 sessionStorage.removeItem("logId00");
 sessionStorage.removeItem("logToken00");
 sessionStorage.removeItem("logName00");
 
 window.location.replace("/");
 
 
 }    

}

/***************** EDIT TEAM FUNCTION END  ******************/




return(
    <>

<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>React App</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

   {/*}   <Sidebar /> */}
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">

          

                 {/*  SUCCESS CARD START */}
                 <div class="d-flex justify-content-center">
               <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Team Member Details Updated Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to continue.</p>
                      <a href="/adminpanel-dashboard-teams"><button class="mt-3 btn btn-outline-success">Continue</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/*  SUCCESS CARD END */}


          <div className="page-header flex-wrap">
          <div className="header-left">
           <button style={{marginTop:"2rem",marginLeft:"2rem"}} class="btn btn-outline-info" onClick={()=>{ window.location.replace("adminpanel-dashboard-teams")}}>  Back </button>
            </div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">ADMIN PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">EDIT TEAM ACCOUNT DETAILS</p>
                  </a>
                </div>
          {/*}     <button type="button" className="btn btn-primary mt-2 mt-sm-0 btn-icon-text"  onClick={()=>{ 
               const createForm = document.getElementById('create-form');
               const currentDisplay = createForm.style.display;
               createForm.style.display = currentDisplay === 'none' ? 'block' : 'none'; }}>
                  <i className="mdi mdi-plus-circle"></i>New Loan Request</button>  */}
              </div>
            </div>


                <div class="card">
              
                  <div class="card-body" style={{textAlign:"left"}}>
                    <h4 class="card-title">Edit Team Member Details</h4>
                    <div class="form-sample">
                      <p class="card-description">edit team member details here</p>
                      <code>{error_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Code</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="CODE0001" id="code" value={code} />
                              <small class="text-muted" style={{fontSize:"0.7rem"}}>this field cannot be changed</small>
                              <code>{code_er}</code>
                            </div>
                          </div>
                        </div>
                   {/*}     <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} placeholder="Branch Level" id="type" value={type} onChange={updatetype}  >
                            <option value="Branch Head">Branch Head</option>
                            <option value="Sales">Sales</option>
                            <option value="Operations">Operations</option>
                            <option value="HR">HR</option>
                            <option value="Other">Other</option>
                            </select>
                            <code>{type_er}</code>
                            </div>
                          </div>
                        </div>  */} 
                    {/*}    </div>
                      <div class="row">*/}
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Name" id="name" value={name} />
                              <small class="text-muted" style={{fontSize:"0.7rem"}}>this field cannot be changed</small>
                              <code>{name_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Username</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Username"  id="username" value={username} />
                              <small class="text-muted" style={{fontSize:"0.7rem"}}>this field cannot be changed</small>
                              <code>{username_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Status</label>
                            <div class="col-sm-9">
                              <select class="form-control" style={{padding:"1rem"}} id="admin_status" value={admin_status} onChange={updateadmin_status}>
                              <option value="active">active</option>
                              <option value="inactive">inactive</option>
                              </select>
                              <code>{admin_status_er}</code>
                            </div>
                          </div>
                         </div>
                        </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Password</label>
                            <div class="col-sm-9">
                              <input type="password" class="form-control" placeholder="My Password"  id="password" value={password} onChange={updatepassword} />
                              <code>{password_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Confirm Password</label>
                            <div class="col-sm-9">
                            <input type="password" class="form-control" placeholder="My Password"  id="confirm_password" value={confirm_password} onChange={updateconfirm_password} />
                            <code>{confirm_password_er}</code>
                            </div>
                          </div>
                        </div>   
                        </div>
                          <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Type</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Type"  id="type" value={type} onChange={updatetype} />
                              <code>{type_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                     
                      <div class="form-group">
                        <label for="exampleTextarea1">Remarks</label>
                        <textarea  class="form-control" rows="2" placeholder="Add your Remarks here" id="remarks" value={remarks} onChange={updateremarks} />
                        <code>{remarks_er}</code>
                      </div>

                
                      
                        <button class="btn btn-lg btn-success" style={{fontWeight:"bold"}} id="emp-submit-btn" onClick={edit_team}>Edit Team Member</button>
                      
                       
    
                     
                   
                    </div>
                  </div>
                </div>

                </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
    </>

);
}
//}

export default Admin_edit_team;